import {Component, Input, OnInit} from '@angular/core';
import {AbstractComponent} from "@components";
import {Lookups, RaceRegistration} from "@model";
import {TranslocoService} from "@ngneat/transloco";
import {MY_TRACEY_OVERVIEW, ORDER_DETAILS} from "src/app/app-routing.module";
import {ActivatedRoute, Router} from "@angular/router";

@Component({
  selector: 'app-my-tracey-orders',
  templateUrl: './my-tracey-orders.component.html',
  styleUrl: './my-tracey-orders.component.scss',
  standalone: false
})
export class MyTraceyOrdersComponent extends AbstractComponent implements OnInit {
  @Input({required: true}) languages: Lookups[] = [];
  @Input() registrations: RaceRegistration[] = []

  constructor(public translocoService: TranslocoService,
              private router: Router, private route: ActivatedRoute,) {
    super();
  }

  ngOnInit(): void {
  }

  goToOrder(registration: RaceRegistration) {
    this.router.navigate([ORDER_DETAILS], {
      queryParams: {orderId: registration.id,}
    });
  }

  goBack() {
    this.router.navigate([MY_TRACEY_OVERVIEW]);
  }

}
